import type { State, Actions } from './types'
import {
  FETCHED,
  LOCATION_FETCHED,
  LOGOUT,
  FETCHED_IS_REGISTERED_FOR_ONRAMP,
} from './actionTypes'

const initialState = {}

export default function (
  state = initialState as State,
  action: Actions,
): State {
  switch (action.type) {
    case FETCHED:
      return {
        ...state,
        ...action.payload,
      }
    case FETCHED_IS_REGISTERED_FOR_ONRAMP:
      return {
        ...state,
        isRegisteredForOnRamp: action.payload,
      }
    case LOCATION_FETCHED:
      return {
        ...state,
        ...action.payload,
      }

    case LOGOUT:
      return {}
    default:
      return state
  }
}
